import React from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { mapValues } from 'lodash/fp'

import Layout from '../../components/Layout'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Table from '../../components/Table'
import Search from '../../components/Search'

import { AppContext } from '../App'
import editIcon from '../../images/editIcon.svg'
import addIcon from '../../images/addIcon.svg'

import withLoading from '../../utils/withLoading'
import { normalizeSortState } from '../../components/Table/convertSortState'
import withQueryParams from '../../utils/withQueryParams'
import { Hidden } from '../../styles/Shared'

export const USERS_ENDPOINT = '/user/rest/user/search'

const LoadingTable = withLoading(Table)
const decorate = withQueryParams

class UserList extends React.Component {
  static contextType = AppContext

  state = {
    sort: {
      id: 'desc',
    },
    ready: false,
    users: [],
    meta: {
      limit: 20,
      page: 0,
    },
    filters: { search: '' },
  }

  fetchUsers = async (resetPage = true) => {
    const { filters, meta, sort } = this.state
    this.props.setParams({ filters, meta, sort })
    this.setState(
      {
        ready: false,
        filters: this.state.filters,
        meta: {
          ...this.state.meta,
          page: resetPage ? 0 : this.state.meta.page,
        },
      },
      async () => {
        const { meta } = this.state
        try {
          const response = await this.context.withAuth(USERS_ENDPOINT, {
            method: 'POST',
            payload: {
              filters: this.state.filters,
              meta: { ...meta, sorts: normalizeSortState(this.state.sort) },
            },
          })
          const users = response.models

          this.setState({ users, meta: response.meta })
        } catch (e) {
          console.log(e)
        }
        this.setState({ ready: true })
      }
    )
  }

  onPageChange = (index) => {
    this.setState({ meta: { ...this.state.meta, page: index } }, () =>
      this.fetchUsers(false)
    )
  }

  onSearchChange = (search) => {
    this.setState({ filters: { ...this.state.filters, search } }, () =>
      this.fetchUsers()
    )
  }

  onSortedChange = (sort) => {
    this.setState({ sort }, () => {
      this.fetchUsers(false)
    })
  }

  componentDidMount() {
    const searchParams = this.props.getParams()
    try {
      const params = mapValues(JSON.parse, searchParams)
      this.setState({ ...this.state, ...params }, () => this.fetchUsers(false))
    } catch (e) {
      this.fetchUsers()
    }
  }
  render() {
    return (
      <Layout>
        <>
          <Heading title="Lista użytkowników">
            <Hidden>
              <span aria-live="polite">{`Liczba znalezionych wyników = ${
                this.state.users != null ? this.state.users.length : 0
              }`}</span>
            </Hidden>
            <Search
              width={300}
              placeholder="Wyszukaj"
              meta={{}}
              input={{
                onChange: this.onSearchChange,
                value: this.state.filters.search,
              }}
            />
            <Button
              link="/app/users/add"
              label="Nowy"
              icon={addIcon}
              width="auto"
              altTag=""
              imgAriaHidden={true}
            />
          </Heading>
          <LoadingTable
            ready={this.state.ready}
            data={this.state.users}
            page={this.state.meta.page}
            total={this.state.meta.total}
            getLoadingProps={() => ({
              'aria-hidden': true,
              role: 'none',
            })}
            defaultPageSize={this.state.meta.limit}
            onPageChange={this.onPageChange}
            onSortedChange={this.onSortedChange}
            order={this.state.sort}
            columns={[
              {
                Header: 'Nr',
                id: 'id',
                accessor: 'id',
                sortable: true,
                getProps: () => ({
                  role: undefined,
                }),
              },
              {
                id: 'firstName',
                Header: 'Imię',
                accessor: 'firstName',
                sortable: true,
                getProps: () => ({
                  role: undefined,
                }),
              },
              {
                id: 'lastName',
                accessor: 'lastName',
                Header: 'Nazwisko',
                sortable: true,
                getProps: () => ({
                  role: undefined,
                }),
              },
              {
                id: 'login',
                accessor: 'login',
                Header: 'Login',
                getProps: () => ({
                  role: undefined,
                }),
              },

              {
                accessor: 'emailAddress',
                Header: 'Email',
                getProps: () => ({
                  role: undefined,
                }),
              },
              {
                id: 'createdAt',
                accessor: 'creationDate',
                Header: 'Data Utworzenia',
                getProps: () => ({
                  role: undefined,
                }),
              },
              {
                Header: '',
                sortable: false,
                Cell: ({ original }) => (
                  <Img
                    alt="edit user"
                    src={editIcon}
                    onClick={() =>
                      navigate(`/app/users/${original.id}`, {
                        state: {
                          user: original,
                        },
                      })
                    }
                  />
                ),
              },
            ]}
          />
        </>
      </Layout>
    )
  }
}

const Img = styled.img`
  margin-bottom: 0;
  cursor: pointer;
`

export default decorate(UserList)
